import { createDomain } from 'effector';

import api from 'api';

import DocumentScansService from 'services/DocumentScansService';

const domain = createDomain('api/documents');

const DocumentsFxs = {
    generateFx: domain.effect(api.documents.generate),
    getDocumentValidityFx: domain.effect(api.documents.getDocumentValidity),
    createDocumentFx: domain.effect(api.documents.createDocument),
    deleteScanFx: domain.effect(api.documents.deleteScan),
    downloadDocumentFx: domain.effect(api.documents.downloadDocument),
    getDocumentsByEmailFx: domain.effect(api.documents.getDocumentsByEmail),
    getJSONbyDocIDFx: domain.effect(api.documents.getJSONbyDocID),
    getSamplesFx: domain.effect(api.documents.getSamples),
    updateStatusFx: domain.effect(api.documents.updateStatus),
    getSignedUrlFx: domain.effect(api.documents.getSignedUrl),
    getSignedUrlByDocumentIdAndNameFx: domain.effect(api.documents.getSignedUrlByDocumentIdAndName),
    uploadScanFx: domain.effect(DocumentScansService.upload),
    downloadScanFx: domain.effect(DocumentScansService.download),
    generateDocByCodeFx: domain.effect(api.documents.generateDocByCode),
};

export default DocumentsFxs;
